(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .component('painelHistoricoUsosMaquinas', {
      controller: 'HistoricoUsosMaquinasCtrl',
      templateUrl: 'views/propriedade/historico-usos-maquinas.html'
    });

}());
